import React, { Fragment, useContext, useEffect, useState } from 'react'
import axios from 'axios'
import Loading from '../Loading/Loading.jsx'
import { Link } from 'react-router-dom'
import Pagination from '../Pagination/Pagination.jsx'
import Swal from 'sweetalert2';
import { UserContext } from '../../Context/UserContext.js'
import CustomTitle from '../CustomTitle/CustomTitle.jsx'



export default function Price() {

   const [pageCount, setPageCount] = useState(0)
   const [loading, setLoading] = useState(false)
   const [company, setCompany] = useState([]);
   const { userToken } = useContext(UserContext);

   const header = {
      token: `${process.env.REACT_APP_BEARER_TOKEN} ${userToken || localStorage.getItem("token")}`
   }




   //& Get Test Data and Current Page :
   const fetchData = async (currentPage) => {
      setLoading(true)
      await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/company?page=${currentPage}`, { headers: header })
         .then(({ data }) => {
            setCompany(data.companies);
            setLoading(false);
            setPageCount(data.metadata.numberOfPages);
         })
         .catch((error) => {
            Swal.fire({
               title: error.response?.data.message,
               text: "Please Try Again",
               icon: "error",
               width: "400px"
            });
            console.log(error);
            setLoading(false)
         })
   }


   //& Handle page Count :
   const handlePageClick = (data) => {
      fetchData(data?.selected + 1)
   }


   useEffect(() => {
      fetchData()
   }, [])

   return (
      <Fragment>
         <CustomTitle title="مقدمى الخدمات " />

         <div className="container price">
            <h2 className='main-header mt-5 pt-5'>اختيار مقدم الخدمة </h2>
            <div className='under-header'></div>

            <div className="row justify-content-evenly gap-1 mb-5">

               {loading ? <Loading /> : <>

                  {company.map((ele) => {
                     return (
                        <div className="col-3 col-md-2 card_item " key={ele._id}>
                           <Link to={`/addTest/${ele._id}`}>
                              <div className="div_image text-center m-auto bg-light-subtle">
                                 <img src={ele.logo} alt="imageCover" className='w-100 rounded-circle p-2' />
                              </div>
                              <h6 className='fw-bold main-color text-center mt-2'>{ele.name}</h6>
                           </Link>
                        </div>
                     )
                  })}
               </>}

            </div>

            <Pagination handlePageClick={handlePageClick} pageCount={pageCount} />
         </div>
      </Fragment>
   )
}
